var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldSrc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5938 8.5835C15.5938 12.7256 12.2359 16.0835 8.09375 16.0835M15.5938 8.5835C15.5938 4.44136 12.2359 1.0835 8.09375 1.0835M15.5938 8.5835H0.59375M8.09375 16.0835C3.95161 16.0835 0.59375 12.7256 0.59375 8.5835M8.09375 16.0835C9.96971 14.0297 11.0358 11.3645 11.0938 8.5835C11.0358 5.80252 9.96971 3.13726 8.09375 1.0835M8.09375 16.0835C6.21779 14.0297 5.15169 11.3645 5.09375 8.5835C5.15169 5.80252 6.21779 3.13726 8.09375 1.0835M0.59375 8.5835C0.59375 4.44136 3.95161 1.0835 8.09375 1.0835",
    stroke: "#71C6FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldSrc);
export default __webpack_public_path__ + "static/media/world_src.dbe19c8b6d097762e85b63398049528f.svg";
export { ForwardRef as ReactComponent };